/*
 * ShopDetails Messages
 *
 * This contains all the text for the ShopDetails component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  ageValidata_title: {
    id: 'app.conversion.containers.LayoutOne.ShelvesSections.text',
    defaultMessage:
      'Para ver los productos de esta sección es necesario que seas mayor de edad.',
  },
  ageValidata_sub_title: {
    id: 'app.conversion.containers.LayoutOne.ShelvesSections.link',
    defaultMessage: 'Validar edad',
  },
  menuFilterNoResults: {
    id: 'app.shopDetails.containers.LayoutOne.menuFilterNoResults',
    defaultMessage: 'No encontramos "{query}" en el menú',
  },
  feedbackButtonTitle: {
    id: 'app.shopDetails.containers.LayoutOne.feedbackButtonTitle',
    defaultMessage: '¿Querés comentarnos algo sobre este restaurante?',
  },
  feedbackButtonLink: {
    id: 'app.shopDetails.containers.LayoutOne.feedbackButtonLink',
    defaultMessage: 'Danos tu opinión',
  },
  feedbackModalTitle: {
    id: 'app.shopDetails.containers.LayoutOne.feedbackModalTitle',
    defaultMessage: 'Este restaurante',
  },
  feedbackSuccess: {
    id: 'app.shopDetails.containers.LayoutOne.feedbackSuccess',
    defaultMessage: '¡Gracias por tu opinión!',
  },
});
